import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Box, Backdrop, CircularProgress } from '@mui/material';
import { useSnackbar } from '../../../components/SnackbarProvider';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent/index';
import UnderDevelopmentPage from '../../UnderDevelopmentPage';
import axios from 'axios';
import { BASE_URL, fetchData, postData, deleteData } from '../../Utils/Baseurl';
import { getProjectsMiddleware } from '../../../api/projectMiddleware';


const TestCaseCreation = () => {
    const [project, setProject] = useState('');
    const [projectList, setProjectList] = useState([]);
    const [projectModules, setProjectModules] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [editingTestCaseId, setEditingTestCaseId] = useState(null);
    const open = Boolean(anchorEl);
    const [openAddTestCase, setOpenAddTestCase] = useState(false);
    const [testCaseData, setTestCaseData] = useState({
        title: '',
        description: '',
        preconditions: '',
        owner: '',
        priority: '',
        testCaseState: '',
        testCaseType: '',
        automationStatus: '',
        oneDriveLink: '',
        attachments: null
    });

    const [steps, setSteps] = useState([{ step: '', result: '' }]);
    const [selectedModule, setSelectedModule] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);

    const [loading, setLoading] = useState(false);
    const { showSnackbar } = useSnackbar();

    console.log(projectModules, 'projectModules')

    useEffect(() => {
        fetchProjects();
    }, []);


    const fetchProjects = async () => {
        setLoading(true);
        try {
            const userId = sessionStorage.getItem("currentUser");
            if (userId) {
                const response = await getProjectsMiddleware(userId);
                if (response && response.data) {
                    const formattedProjects = response.data.map(proj => ({
                        value: proj.project_id,
                        label: proj.project_name
                    }));
                    setProjectList(formattedProjects);
                }
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchProjectModules = async (selectedProj) => {
        setLoading(true);
        try {
            if (selectedProj?.value) {
                const response = await fetchData(`api/get_project_folders/${selectedProj.value}/`);
                if (response && response.data) {
                    const formattedModules = {
                        name: selectedProj.label || "Modules",
                        subModules: response.data.map(module => ({
                            id: module.module_id || module.id,
                            name: module.module_name || module.name
                        }))
                    };
                    setProjectModules(formattedModules);
                }
            }
        } catch (error) {
            console.error("Error fetching project modules:", error);
        } finally {
            setLoading(false);
        }
    }

    const [fetchedTestCases, setFetchedTestCases] = useState([]);
    const [selectedModuleName, setSelectedModuleName] = useState('');

    const fetchTestCases = async (moduleId) => {
        if (!moduleId) {
            console.warn("fetchTestCases called with invalid moduleId:", moduleId);
            return;
        }
        setLoading(true);
        try {
            const response = await postData(`api/get_testcases/`, {
                folder_id: moduleId
            });
            if (response && response.data) {
                setFetchedTestCases(response.data);
            } else {
                setFetchedTestCases([]);
            }
        } catch (error) {
            console.error("Error fetching test cases:", error);
            setFetchedTestCases([]);
        } finally {
            setLoading(false);
        }
    };

    const handleListClick = (id) => {
        console.log("handleListClick id:", id);
        if (id === undefined || id === null) return;

        setSelectedModule(id);
        const module = projectModules?.subModules?.find(m => m.id === id);
        if (module) {
            setSelectedModuleName(module.name);
            fetchTestCases(id);
        }
    };

    const handleTestCaseDataChange = (field, value) => {
        console.log(field, value, 'optionsValues');
        setTestCaseData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleAddStep = () => {
        setSteps([...steps, { step: '', result: '' }]);
    };

    const handleStepChange = (index, field, value) => {
        const updatedSteps = [...steps];
        updatedSteps[index][field] = value;
        setSteps(updatedSteps);
    };

    const handleDeleteStep = (indexToDelete) => {
        const updated = steps.filter((_, index) => index !== indexToDelete);
        setSteps(updated);
    };

    const handleMenuOpen = (event, subModuleId) => {
        setAnchorEl(event.currentTarget);
        setSelectedId(subModuleId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleAddTestCase = () => {
        setEditingTestCaseId(null);
        setTestCaseData({
            title: '',
            description: '',
            preconditions: '',
            owner: '',
            priority: '',
            testCaseState: '',
            testCaseType: '',
            automationStatus: '',
            oneDriveLink: '',
            attachments: null
        });
        setSteps([{ step: '', result: '' }]);
        setOpenAddTestCase(true);
    };

    const handleCloseAddTestCase = () => {
        setOpenAddTestCase(false);
        setEditingTestCaseId(null);
        setTestCaseData({
            title: '',
            description: '',
            preconditions: '',
            owner: '',
            priority: '',
            testCaseState: '',
            testCaseType: '',
            automationStatus: '',
            oneDriveLink: '',
            attachments: null
        });
        setSteps([{ step: '', result: '' }]);
    }

    const handleEditTestCase = async (id) => {
        setLoading(true);
        try {
            const response = await fetchData(`api/testcase/${id}/`);
            if (response && response.data) {
                const data = response.data;
                setEditingTestCaseId(id);
                setTestCaseData({
                    title: data.title || '',
                    description: data.description || '',
                    preconditions: data.precondtions || '', 
                    owner: data.owner_id || '',
                    priority: data.priority ? { label: data.priority, value: data.priority } : '',
                    testCaseState: data.test_state ? { label: data.test_state, value: data.test_state } : '',
                    testCaseType: data.test_case_type ? { label: data.test_case_type, value: data.test_case_type } : '',
                    automationStatus: data.automation_status ? { label: data.automation_status, value: data.automation_status } : '',
                    oneDriveLink: data.link || '',
                    attachments: null 
                });

                if (data.steps && data.steps.length > 0) {
                    setSteps(data.steps.map(s => ({
                        step: s.action || '',
                        result: s.expected_result || ''
                    })));
                } else {
                    setSteps([{ step: '', result: '' }]);
                }
                setOpenAddTestCase(true);
            }
        } catch (error) {
            console.error("Error fetching test case details:", error);
            showSnackbar('Failed to fetch test case details.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleProjectChange = (selectedProject) => {
        setProjectModules(null);
        setProject(selectedProject);
        setSelectedProject(selectedProject);
        setFetchedTestCases([]);
        setSelectedModuleName('');
        if (selectedProject?.value) {
            fetchProjectModules(selectedProject);
        }
    };

    const handleSaveTestCase = async () => {
        if (!selectedModule) {
            showSnackbar('Please select a module folder before adding a test case.', 'warning');
            return;
        }

        const currentUser = sessionStorage.getItem('user_id');

        setLoading(true);
        try {
            const token = sessionStorage.getItem('token');
            const formData = new FormData();

            formData.append('title', testCaseData.title);
            formData.append('description', testCaseData.description);
            formData.append('precondtions', testCaseData.preconditions);
            formData.append('state', testCaseData.testCaseState?.value || testCaseData.testCaseState);
            formData.append('priority', testCaseData.priority?.value || testCaseData.priority);
            formData.append('test_case_type', testCaseData.testCaseType?.value || testCaseData.testCaseType);
            formData.append('automation_status', testCaseData.automationStatus?.value || testCaseData.automationStatus);
            formData.append('folder', selectedModule);
            formData.append('link', testCaseData.oneDriveLink);
            formData.append('owner_id', currentUser)

            if (testCaseData.attachments) {
                formData.append('attachment', testCaseData.attachments);
            }

            const formattedSteps = steps.map((step, index) => ({
                step_number: index + 1,
                action: step.step,
                expected_result: step.result
            }));

            formData.append('steps', JSON.stringify(formattedSteps));

            let response;
            if (editingTestCaseId) {
                response = await axios.put(`${BASE_URL}api/testcase/${editingTestCaseId}/`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });
            } else {
                response = await axios.post(`${BASE_URL}api/testcase/`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            if (response.status === 200 || response.status === 201) {
                showSnackbar(editingTestCaseId ? 'Test case has been successfully updated.' : 'Test case has been successfully added.', 'success');
                handleCloseAddTestCase();
                fetchTestCases(selectedModule);
            }
        } catch (error) {
            console.error("Error saving test case:", error);
            showSnackbar('Failed to save test case. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteTestCase = async (id) => {
        if (!id) return;
        setLoading(true);
        try {
            const response = await deleteData(`api/testcase/${id}/`);
            if (response) {
                showSnackbar('Test case has been successfully deleted.', 'success');
                fetchTestCases(selectedModule);
            }
        } catch (error) {
            console.error("Error deleting test case:", error);
            showSnackbar('Failed to delete test case. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };


    return (
        <DashboardLayout>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '70vh',
                    width: '100%',
                }}>
                <Navbar />
                <Box sx={{ display: 'flex', flex: 1, }}>
                    <Sidebar project={project} handleProjectChange={handleProjectChange} projectList={projectList} projectModules={projectModules} anchorEl={anchorEl} handleMenuOpen={handleMenuOpen} handleAddTestCase={handleAddTestCase} open={open} handleMenuClose={handleMenuClose} openAddTestCase={openAddTestCase} setOpenAddTestCase={setOpenAddTestCase} testCaseData={testCaseData} steps={steps} setSteps={setSteps} handleAddStep={handleAddStep} handleStepChange={handleStepChange} handleDeleteStep={handleDeleteStep} handleListClick={handleListClick} />
                    <MainContent openAddTestCase={openAddTestCase} setOpenAddTestCase={setOpenAddTestCase} testCaseData={testCaseData} steps={steps} setSteps={setSteps} handleAddStep={handleAddStep} handleStepChange={handleStepChange} handleDeleteStep={handleDeleteStep} handleAddTestCase={handleAddTestCase} testCases={fetchedTestCases} headerName={selectedModuleName} handleTestCaseDataChange={handleTestCaseDataChange} selectedProject={selectedProject} handleSaveTestCase={handleSaveTestCase} handleDeleteTestCase={handleDeleteTestCase} handleEditTestCase={handleEditTestCase} editingTestCaseId={editingTestCaseId} handleCloseAddTestCase={handleCloseAddTestCase} />
                </Box>
            </Box>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>


        </DashboardLayout>
    )
}

export default TestCaseCreation
